import io from "socket.io-client";
import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Form, Button, ListGroup } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { RoomContext } from "../App";
import { NicknameContext } from "../App";
import { socket } from "../App";
import "../index.css";
import { signOut } from "firebase/auth";

import { auth, provider } from "../firebase";
import { signInWithPopup } from "firebase/auth";
import { useAuthState } from "react-firebase-hooks/auth";

import { InputGroup } from "react-bootstrap";
import { Game } from "./game";
import { RoomMenu } from "./roommenu";
import {useRef} from "react";
import {UserContext} from "../App"


export const Lobby = ({room,players, isHost}) => {
    const [ready, setReady] = useState(false);
   // const [user] = useAuthState(auth);
    const {user, setUser} = useContext(UserContext)

    const handleReady = () => {
      setReady(true);
   //   console.log(user)
      socket.emit("ready", {
        room: room,
        nickname: user?.displayName,
      });
  };

    useEffect(() => {
   //     console.log("players",players)
    },[players])

    return (
        <>

<div style={{display:"flex",flexDirection:"column",alignItems:"left"}}>
    <strong>Invite friends!</strong>
    <br/>
    <div>Room PIN {room}</div>
   {/*} <h5 style={{textAlign:"left",color:"white"}}>Upload custom base photo</h5>*/}
   

            <h3 style={{textAlign:"left",color:"black"}}>Players</h3>
            <ListGroup className="mt-3">
                    {players.map((player, index) => (
                      <ListGroup.Item key={index} style={{textAlign:"left"}}>
                        {player.nickname} {player.ready ? "(Ready)" : ""}
                      </ListGroup.Item>
                    ))}
                  </ListGroup>
                  {!ready && (
                  <Button style={{width:"45%"}} variant="light"
                   className="mt-3 mb-3 text-left"
                   onClick={handleReady}>Ready</Button>
                   )}
                  </div>
      </>
    )
}










